'use strict';

angular.module('DoohApps').factory('DoohConfig', ['Constants', 'Environment',
    function DoohConfigFactory(Constants, Environment) {
        var WebPlayer, RestApi, version, storeBaseUrl;
        version = Environment.version;
        storeBaseUrl = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
        RestApi = location.protocol + '//' + Environment.restAPI;
        WebPlayer = location.protocol + '//' + Environment.webPlayerURL + '?v=' + version;

        return {
            version: version,
            RestApi: RestApi,
            RestApiBaseURL: RestApi + '/api/',
            RestApiLoginURL: RestApi + '/Token',
            CheckSessionURL: RestApi + '/api/Account/IsAuthenticated',
            SignalrUrl: RestApi + '/signalr',
            WebPlayerUrl: WebPlayer,
            storeBaseUrl: storeBaseUrl,
            isDebugMode: Environment.isDebugMode,
            isTestMode: Environment.isTestMode
        }
    }]);